export default __webpack_public_path__ + "static/media/email.b9fd5e77.svg";